import angular from 'angular';
import * as async from 'async';
import _ from 'lodash';

import { taxRegimes } from 'src/app/core/constants';

angular.module('history').factory('eInvoiceSetup', ["$mdDialog", "$translate", "restManager", "checkManager", "alertDialog", function($mdDialog, $translate, restManager, checkManager, alertDialog) {

    eInvoiceSetupController.$inject = ["$scope", "$mdDialog", "preferencesData", "billingData"];
    function eInvoiceSetupController($scope, $mdDialog, preferencesData, billingData) {
        $scope.pristineData = preferencesData;
        $scope.preferencesData = _.cloneDeep(preferencesData);
        $scope.taxRegimes = structuredClone(taxRegimes);
        $scope.billingData = billingData;
        $scope.digitalHubCredentials = {};
        $scope.ftpParams = {};

        $scope.step = 'mode-select';

        $scope.cancel = function() {
            return $mdDialog.cancel();
        };

        $scope.deleteMessage = function() {
            $scope.errorMessage = null;
        };

        $scope.getTitle = function() {
            switch($scope.step) {
                case 'merchant-setup':
                    return $translate.instant('HISTORY.E_INVOICE_SETUP.MERCHANT_SETUP_TITLE');
                case 'mode-select':
                    return $translate.instant('HISTORY.E_INVOICE_SETUP.MODE_SELECT_TITLE');
                case 'digitalhub-owned-setup':
                    return $translate.instant('HISTORY.E_INVOICE_SETUP.DIGITAL_HUB_OWNED.TITLE');
                case 'ftp-setup':
                    return $translate.instant('HISTORY.E_INVOICE_SETUP.FTP.TITLE');
            }
        };

        $scope.back = function() {
            $scope.errorMessage = null;

            switch($scope.step) {
                case 'merchant-setup':
                    $scope.step = 'mode-select';
                    break;
                case 'digitalhub-owned-setup':
                case 'ftp-setup':
                    $scope.step = 'merchant-setup';
                break;
            }
        };

        var showErrorMessage = function(messageCode, otherMessage) {
            var errMsg = $translate.instant('HISTORY.E_INVOICE_SETUP.ERRORS.' + messageCode);

            if(!_.isEmpty(otherMessage)) {
                errMsg += ':\n' + otherMessage;
            }

            $scope.errorMessage = errMsg;
        };

        var performSetup = function() {
            var reqBody = {};

            switch($scope.sendMode) {
                case 'digitalHubOwned':
                    _.assign(reqBody, { send_mode: 'digitalhub' });
                    _.assign(reqBody, $scope.digitalHubCredentials);
                break;
                case 'ftp':
                    _.assign(reqBody, { send_mode: 'ftp' });
                    _.assign(reqBody, $scope.ftpParams);
                break;
                case 'download':
                    _.assign(reqBody, { send_mode: 'download' });
                break;
            }

            $scope.isWorking = true;

            restManager.post('e_invoice_setup', reqBody).then(function(result) {
                $mdDialog.hide(result);
            }, function(error) {
                var err;

                if(_.get(error, 'status') === -1) {
                    err = 'OFFLINE';
                } else if(_.get(error, ['data', 'error', 'message', 'error_code'])) {
                    err = error.data.error.message.error_code;
                } else {
                    err = 'UNKNOWN_ERROR';
                }

                showErrorMessage(err, error.data.error.message.response);
            }).finally(function() {
                $scope.isWorking = false;
            });
        };

        $scope.confirm = function() {
            $scope.errorMessage = null;

            switch($scope.step) {
                case 'merchant-setup':
                    var changedPrefs = {};
            
                    var savePreferences = function() {
                        $scope.isWorking = true;

                        async.eachOfSeries(changedPrefs, function(val, key, cb) {
                            if(!_.startsWith(key, '_')) {
                                checkManager.setShopPreferenceSync(key, val).then(function() { cb(); }, cb);
                            } else {
                                cb();
                            }
                        }, function(err, res) {
                            if(err) {

                            } else {
                                angular.copy($scope.preferencesData, $scope.pristineData);
                                $scope.isWorking = false;
                                
                                switch($scope.sendMode) {
                                    case 'digitalHubOwned':
                                        $scope.step = 'digitalhub-owned-setup';
                                    break;
                                    case 'ftp':
                                        $scope.step = 'ftp-setup';
                                    break;
                                    case 'download':
                                        performSetup();
                                    break;
                                }
                            }
                        });
                    };
            
                    var getChangedPreferences = function(current, previous) {
                        _.forIn(current, function(val, key) {
                            if(!_.isEqual(val, previous[key])) {
                                _.set(changedPrefs, [key], val);
                            }
                        });
                    };
            
                    getChangedPreferences($scope.preferencesData, $scope.pristineData);
                    savePreferences();
        
                    $scope.preferencesDataReset = _.cloneDeep($scope.preferencesData);
                break;
                case 'mode-select':
                    $scope.step = 'merchant-setup';
                break;
                case 'digitalhub-owned-setup':
                    performSetup();
                break;
                case 'ftp-setup':
                    performSetup();
                break;
            }
        };

        $scope.isConfirmDisabled = function() {
            switch($scope.step) {
                case 'merchant-setup':
                    return _.get($scope, ['eInvoiceMerchantForm', '$invalid']);
                case 'mode-select':
                    return _.isEmpty($scope.sendMode);
                case 'digitalhub-owned-setup':
                    return _.get($scope, ['eInvoiceDigitalHubForm', '$invalid']);
                case 'ftp-setup':
                    return _.get($scope, ['eInvoiceFtpForm', '$invalid']);
            }
        };

        $scope.getSendModePrice = function(sendMode) {
            return $translate.instant(billingData.reseller_scloby_id ? 'HISTORY.E_INVOICE_SETUP.RESELLER_PRICE_INFO' : 'HISTORY.E_INVOICE_SETUP.' + sendMode + '_PRICE');
        };

        $scope.compileMerchant = async function() {
            const vatCode = $scope.preferencesData['e_invoice.merchant.vat_code'];

            try {
                const result = await restManager.getOne('validate_vat', vatCode);
        
                if(!result) {
                    return alertDialog.show($translate.instant('SETTINGS.SETTINGS.NO_RESULTS'));
                }
                
                Object.assign($scope.preferencesData, {
                    'e_invoice.merchant.tax_code': result.tax_number?.slice(0, 16) || '',
                    'e_invoice.merchant.company_name': result.name,
                    'e_invoice.merchant.vat_code': result.vat_number,
                    'e_invoice.merchant.country': 'IT',
                });
    
                Object.assign($scope.preferencesData, {
                    'e_invoice.merchant.head_office.street': result.address_street,
                    'e_invoice.merchant.head_office.number': result.address_number,
                    'e_invoice.merchant.head_office.zip': result.address_zip,
                    'e_invoice.merchant.head_office.city': result.address_city,
                    'e_invoice.merchant.head_office.prov': result.address_prov,
                    'e_invoice.merchant.head_office.country': 'IT'
                });
            } catch(error) {
                alertDialog.show($translate.instant('SETTINGS.SETTINGS.NO_INFO_FOUND'));
            }
        };
    }

    var eInvoiceSetup = {
        show: function() {
            if(!checkManager.isFunctionUserEnabledOptin('settings.enabled')) {
                throw 'OWNER_ACCOUNT_REQUIRED';
            }

            return $mdDialog.show({
                controller: eInvoiceSetupController,
                template: require('./e-invoice-setup.html'),
                resolve: {
                    preferencesData: function() {
                        return checkManager.getShopPreferences('e_invoice');
                    },
                    billingData: function() {
                        return restManager.getOne('billing_data').catch(function(error) {
                            if(error?.data?.error?.message?.owner_data) {
                                return error.data.error.message.owner_data;
                            } else {
                                throw 'UNKNOWN_ERROR';
                            }
                        });
                    }
                }
            });
        }
    };

    return eInvoiceSetup;
}]);
